import { configureStore } from "@reduxjs/toolkit";

import announcementReducer from "./announcement";
import authReducer from "./auth";
import bankReducer from "./bank";
import bettingrecordReducer from "./bettingrecord";
import contactReducer from "./contact";
import depositReducer from "./deposit";
import gameReducer from "./game";
import masterReducer from "./master";
import messageReducer from "./message";
import ordersReducer from "./orders";
import retriveReducer from "./retrive";
import userReducer from "./user";
import withdrawReducer from "./withdraw";

const rootReducers = {
  auth: authReducer,
  master: masterReducer,
  game: gameReducer,
  bettingRecord: bettingrecordReducer,
  retrive: retriveReducer,
  user: userReducer,
  deposit: depositReducer,
  bank: bankReducer,
  withdraw: withdrawReducer,
  announcement: announcementReducer,
  orders: ordersReducer,
  contact: contactReducer,
  message: messageReducer,
};

const store = configureStore({
  reducer: rootReducers,
});

export default store;
